import React, { FC, useCallback, useEffect, useMemo, useState } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { fetchCapExCategoriesForBuyer } from '../../thunks/invoices_thunks';
import { Form, Input, Modal, Select, Spin } from 'antd';
import ModalFormFooter from '../common/ModalFormFooter';
import {
	capexAssociationRestCrudThunksForBuyer,
	capexAssociationRestCrudThunksForSupplier,
} from '../../thunks/capex_association_thunks';
import { nullSafeGet, nullSafeGetOrElse } from '../../utils/DataAccessUtils';
import CapExCategoryInput from './CapExCategoryInput';
import { ROLE_TYPES } from '../../utils/DataConstants';

const FORM_ID = 'capex-category-form';

const CapExAdditionalInfoPopup: FC<any> = ({
	onCancel,
	saveCapExAssociation,
	workOrder,
	onSuccess,
}): React.ReactElement => {
	const [saving, setSaving] = useState(false);

	const handleSubmit = useCallback(
		(values) => {
			setSaving(true);

			const capExCategoryId = nullSafeGet('name.capExCategoryId', values);
			const capExCategory = nullSafeGet('name.capExCategory', values) || values.name; // Handle both cases

			saveCapExAssociation({
				workOrderId: workOrder.id,
				...(capExCategoryId && { capExCategoryId }),
				capExCategory,
			})
				.then((res) => onSuccess(res))
				.finally(() => setSaving(false));
		},
		[onSuccess, saveCapExAssociation, workOrder]
	);

	return (
		<Modal
			visible={true}
			title="Add CapEx Category"
			onCancel={onCancel}
			footer={null}
			closable={true}
		>
			<Form
				id={FORM_ID}
				layout="vertical"
				initialValues={{}}
				requiredMark={false}
				onFinish={handleSubmit}
			>
				<Form.Item
					name="name"
					label="CapEx Category"
					rules={[
						{
							required: true,
							validator: (_, value) => {
								if (!nullSafeGet('capExCategory', value)) {
									return Promise.reject('Please select/enter a capEx category!');
								}

								return Promise.resolve();
							},
						},
					]}
					initialValue={{
						capExCategoryId: workOrder.capExCategoryId,
						capExCategory: workOrder.capExCategory,
					}}
				>
					<CapExCategoryInput />
				</Form.Item>
				<ModalFormFooter
					okText="Add Category"
					cancelText="Skip"
					loading={saving}
					formId={FORM_ID}
					onCancelClick={onCancel}
				/>
			</Form>
		</Modal>
	);
};

const mapDispatchToProps = (dispatch, ownProps) => ({
	saveCapExAssociation: (entity) =>
		dispatch(
			ownProps.userType === ROLE_TYPES.SUPPLIER
				? capexAssociationRestCrudThunksForSupplier.create(entity)
				: capexAssociationRestCrudThunksForBuyer.create(entity)
		),
});

const ComponentWithoutUserType = withRouter(
	connect(null, mapDispatchToProps)(CapExAdditionalInfoPopup)
);

export default connect(
	(state) => ({
		userType: (state as any).session.userType,
	}),
	() => ({})
)(ComponentWithoutUserType);
